<app-shared-dialog
  [title]="'settings.team_details' | translate"
  [options]="dialogOptions"
  (cancel)="close()">
  <div class="team-detail-dialog__body">
    <div class="team-detail-dialog__identity">
      <span class="team-detail-dialog__monogram">{{ getTeamInitials() }}</span>
      <div>
        <p class="team-detail-dialog__name">{{ team.name }}</p>
        <p class="team-detail-dialog__description">{{ team.description || emptyStateValue }}</p>
      </div>
    </div>

    <div class="team-detail-dialog__meta">
      <span class="team-detail-dialog__member-badge">
        {{ getMemberCount() }} {{ 'settings.members' | translate | lowercase }}
      </span>
      <span class="team-detail-dialog__last-edited">
        {{ 'settings.last_edited' | translate }}: {{ getLastEdited() }}
      </span>
    </div>

    <div class="team-detail-dialog__section">
      <p class="team-detail-dialog__section-label">{{ 'settings.members' | translate }}</p>

      <div class="team-detail-dialog__members" *ngIf="getMembers().length; else noMembers">
        <div
          class="team-detail-dialog__member"
          *ngFor="let member of getMembers(); trackBy: trackByMemberId">
          <span
            class="team-detail-dialog__member-avatar"
            [style.background]="getUserColor(member)">
            {{ getUserInitials(member) }}
          </span>
          <span class="team-detail-dialog__member-name">{{ member.name || emptyStateValue }}</span>
        </div>
      </div>

      <ng-template #noMembers>
        <p class="team-detail-dialog__empty">{{ 'settings.no_members' | translate }}</p>
      </ng-template>
    </div>
  </div>

  <div customConfirm class="team-detail-dialog__footer">
    <ui-button
      type="danger"
      icon="trash-cc"
      [label]="('common.delete' | translate) | uppercase"
      (click)="onDeleteTeam()">
    </ui-button>

    <ui-button
      type="primary"
      icon="pen-cc"
      [label]="('common.edit' | translate) | uppercase"
      (click)="onEditTeam()">
    </ui-button>
  </div>
</app-shared-dialog>
